import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { BusinesLogicService } from '../../services/business-logic.service';
import { ModalHelper } from '../../components/modal/modal.helper';
import { UtilsService } from '../../services/utils.service';
import { DatePipe } from '@angular/common';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

declare var $: any;

@Component({
    selector: 'app-history',
    templateUrl: './history.component.html',
    styleUrls: ['./history.component.css']
})
export class HistoryComponent implements OnInit {

    @Input() id: string;

    public historyList: any[] = [];
    public turn: object = {};
    public modalLoaded: boolean = false;

    private destroy$ = new Subject();

    constructor(public _data: DataService,
        private _blogic: BusinesLogicService,
        private _utils: UtilsService,
        private _modal: ModalHelper,
        private datePipe: DatePipe) { }

    ngOnInit() {
        let self = this;
        $('#historyModal').on('hidden.bs.modal', function (e) {
            self.turn = {};
            self.historyList = [];
        })
    }

    ngOnDestroy() {
      this.destroy$.next();
      this.destroy$.complete();
    }

    /* Get the paused turn list */
    private _getHistoryList(turn, id): void {

        this.turn = turn;
        let params: object = {
            turn_id: turn.id
        };
        this._blogic.getAssist(params)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
                (response: any) => {
                    this.historyList = response;

                    this._modal.show(id);
                }
            );
        this.modalLoaded = true;
    }

    /* Open paused modal */
    public openHistoryModal(turn, id): void {
        this._getHistoryList(turn, id);
    }

}
